import { call, put, select } from "redux-saga/effects"

import {
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAILURE,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAILURE,
  FETCH_EVENT_DETAILS_SUCCESS,
  FETCH_EVENT_DETAILS_FAILURE,
  FETCH_EVENT_TICKETS_SUCCESS,
  FETCH_EVENT_TICKETS_FAILURE,
  FETCH_EVENT_TICKETS_EXCEL_SUCCESS,
  FETCH_EVENT_TICKETS_EXCEL_FAILURE,
  CREATE_EVENT_BOOKING_ORDER_SUCCESS,
  CREATE_EVENT_BOOKING_ORDER_FAILURE,
  VERIFY_EVENT_PAYMENT_SUCCESS,
  VERIFY_EVENT_PAYMENT_FAILURE,
} from "../../types/event"

import {
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_FAILURE,
  CREATE_CATEGORY_SUCCESS,
  CREATE_CATEGORY_FAILURE,
  UPDATE_CATEGORY_SUCCESS,
  UPDATE_CATEGORY_FAILURE,
  DELETE_CATEGORY_SUCCESS,
  DELETE_CATEGORY_FAILURE,
  FETCH_CATEGORY_DETAILS_SUCCESS,
  FETCH_CATEGORY_DETAILS_FAILURE,
} from "../../types/category"

import EventsApi from "../../../api/events"
import categoryApi from "../../../api/category"

const getAuthToken = state => state.auth.token

// Worker to fetch all events
export function* fetchEventsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [EventsApi, "fetchEvents"],
      token,
      action.payload
    )

    if (response.status === 200 || response.status === 201) {
      let payload = {}
      const status = action.payload ? action.payload.filter : undefined
      switch (status) {
        case "all-past":
          payload = {
            allPastList: response.data.events || [],
            message: response.message,
          }
          break
        case "all-upcoming":
          payload = {
            allUpcomingList: response.data.events || [],
            message: response.message,
          }
          break
        case "active-past":
          payload = {
            activePastList: response.data.events || [],
            message: response.message,
          }
          break
        case "active-upcoming":
          payload = {
            activeUpcomingList: response.data.events || [],
            message: response.message,
          }
          break
        case "all-active":
          payload = {
            allActiveList: response.data.events || [],
            message: response.message,
          }
          break
        default:
          payload = { allEvents: response.data.events || [] }
      }
      yield put({ type: FETCH_EVENTS_SUCCESS, payload })
    } else {
      yield put({
        type: FETCH_EVENTS_FAILURE,
        payload: {
          message: response.error || response.message || "Failed to fetch PVS",
        },
      })
    }
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.message ||
      "Something went wrong..."
    yield put({ type: FETCH_EVENTS_FAILURE, payload: { message } })
  }
}

export function* createEventBookingOrderWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield EventsApi.createEventBookingOrder(
      action.payload.data,
      token
    )

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: CREATE_EVENT_BOOKING_ORDER_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: CREATE_EVENT_BOOKING_ORDER_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: CREATE_EVENT_BOOKING_ORDER_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* verifyEventPaymentWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield EventsApi.verifyEventPayment(
      action.payload.data,
      token
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: VERIFY_EVENT_PAYMENT_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: VERIFY_EVENT_PAYMENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: VERIFY_EVENT_PAYMENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to fetch event details
export function* fetchEventDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const eventId = action.payload
    const response = yield call(EventsApi.getEventDetails, eventId, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_EVENT_DETAILS_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: FETCH_EVENT_DETAILS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_EVENT_DETAILS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to fetch event tickets
export function* fetchEventsTicketsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    // const response = yield call(
    //   EventsApi.fetchEventsTickets,
    //   action.payload,
    //   token
    // )
    const response = yield EventsApi.fetchEventsTickets(action.payload, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_EVENT_TICKETS_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: FETCH_EVENT_TICKETS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_EVENT_TICKETS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to fetch event tickets Excel
export function* fetchEventsTicketsExcelWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield EventsApi.fetchEventsTicketsExcel(
      action.payload,
      token
    )

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_EVENT_TICKETS_EXCEL_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: FETCH_EVENT_TICKETS_EXCEL_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_EVENT_TICKETS_EXCEL_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to create an event
export function* createEventWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield EventsApi.createEvent(action.payload, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: CREATE_EVENT_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: CREATE_EVENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: CREATE_EVENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to update an event
export function* updateEventWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield EventsApi.updateEvent(action.payload, token)

    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_EVENT_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else if (
      response.status === 404 ||
      response.status === 400 ||
      response.status === 500
    ) {
      let failureAction = {
        type: UPDATE_EVENT_FAILURE,
        payload: { error: response.data.message },
      }
      yield put(failureAction)
    } else {
      yield put({
        type: UPDATE_EVENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_EVENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

// Worker to delete an event
export function* deleteEventWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const eventId = action.payload.id
    const response = yield call(EventsApi.deleteEvent, eventId, token)
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: DELETE_EVENT_SUCCESS,
        payload: { data: eventId, message: response.message },
      })
    } else {
      yield put({
        type: DELETE_EVENT_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: DELETE_EVENT_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* fetchCategoriesWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [categoryApi, "fetchCategories"],
      token,
      action.payload
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_CATEGORIES_SUCCESS,
        payload: {
          data: response.data.categories || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: FETCH_CATEGORIES_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_CATEGORIES_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* createCategoryWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [categoryApi, "createCategory"],
      token,
      action.payload
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: CREATE_CATEGORY_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: CREATE_CATEGORY_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: CREATE_CATEGORY_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* updateCategoryWorker(action) {
  try {
    const { categoryData } = action.payload
    const token = yield select(getAuthToken)
    const response = yield call(
      [categoryApi, "updateCategory"],
      token,
      categoryData
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: UPDATE_CATEGORY_SUCCESS,
        payload: { data: response.data || response, message: response.message },
      })
    } else {
      yield put({
        type: UPDATE_CATEGORY_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: UPDATE_CATEGORY_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* deleteCategoryWorker(action) {
  try {
    const categoryId = action.payload
    const token = yield select(getAuthToken)
    const response = yield call(
      [categoryApi, "deleteCategory"],
      token,
      categoryId
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: DELETE_CATEGORY_SUCCESS,
        payload: { data: categoryId, message: response.message },
      })
    } else {
      yield put({
        type: DELETE_CATEGORY_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: DELETE_CATEGORY_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}

export function* fetchCategoryDetailsWorker(action) {
  try {
    const token = yield select(getAuthToken)
    const response = yield call(
      [categoryApi, "getCategoryDetails"],
      token,
      action.payload
    )
    if (response.status === 200 || response.status === 201) {
      yield put({
        type: FETCH_CATEGORY_DETAILS_SUCCESS,
        payload: {
          data: response.data.category || response,
          message: response.message,
        },
      })
    } else {
      yield put({
        type: FETCH_CATEGORY_DETAILS_FAILURE,
        payload: { data: null, message: response.error || response.message },
      })
    }
  } catch (error) {
    yield put({
      type: FETCH_CATEGORY_DETAILS_FAILURE,
      payload: { data: null, message: error.message },
    })
  }
}
